<template>
  <b-modal
      id="advance-filter-modal"
      :scrollable="true"
      title="Advance Search"
      header-bg-variant="success"
      size="md"
      centered
      hide-footer>
      <b-row>
        <b-col>
          <b-form-group label="License plate">
            <b-form-input v-model="form.licensePlate" size="sm" />
          </b-form-group>
          <b-form-group label="Make">
            <b-form-input v-model="form.make" size="sm" />
          </b-form-group>
          <b-form-group label="Model">
            <b-form-input v-model="form.model" size="sm" />
          </b-form-group>
          <b-form-group label="Zone">
            <b-form-select v-model="form.area" size="sm">
              <option
                v-for="zone in zoneList"
                :key="zone.code"
                :value="zone.name">
                {{ zone.name }}
              </option>
            </b-form-select>
          </b-form-group>
          <b-form-group label="Station">
            <b-form-select v-model="form.station" size="sm">
              <option
                v-for="station in stationList"
                :key="station.code"
                :value="station.name">
                {{ station.name }}
              </option>
            </b-form-select>
          </b-form-group>
          <b-form-group label="Colour code">
            <b-form-select v-model="form.colourCode" size="sm">
              <option value="danger">Red</option>
              <option value="warning">Yellow</option>
              <option value="success">Green</option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <hr>
      <div class="d-flex justify-content-between">
        <b-btn
          variant="secondary"
          size="sm"
          @click="handleReset">
          Reset
        </b-btn>
        <b-btn
          variant="success"
          size="sm"
          @click="$emit('search', form)">
          Apply
        </b-btn>
      </div>
  </b-modal>
</template>

<script>
export default {
  name: 'AdvanceFilter',
  props: {
    zoneList: {
      type: Array,
      default: () => []
    },
    stationList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      form: {}
    }
  },
  methods: {
    handleReset() {
      this.form = {}
    }
  }
}
</script>

<style>

</style>